// ManageCards.js
import React from 'react';
import {
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Divider,
    IconButton,
    Typography,
} from '@mui/material';
import Done from '@mui/icons-material/Done';
import Close from '@mui/icons-material/Close';
import Delete from '@mui/icons-material/Delete';

const ManageCards = ({
    card,
    handleCardDeleteYes,
    handleCardDeleteNo,
    handleDelete,
    index,
    lastItemIndex,
}) => {
    return (
        <React.Fragment key={card.Id}>
            <ListItem>
                <ListItemText primary={`Card ending in ${card.Card}`} />
                <ListItemSecondaryAction
                    style={{
                        display: 'flex',
                    }}
                >
                    {card.buttonsVisible ? (
                        <>
                            <Typography
                                sx={{
                                    display: {
                                        xs: 'none',
                                        sm: 'block',
                                    },
                                    fontSize: '12px',
                                    marginRight: '10px',
                                    marginTop: 'auto',
                                    marginBottom: 'auto',
                                }}
                            >
                                Are you sure?
                            </Typography>
                            <Done
                                onClick={() => handleCardDeleteYes(card)}
                                sx={{
                                    cursor: 'pointer',
                                    color: '#4b6bcc',
                                    marginRight: '10px',
                                }}
                            />
                            <Close
                                onClick={() => handleCardDeleteNo(card.Id)}
                                sx={{
                                    cursor: 'pointer',
                                    color: 'gray',
                                }}
                            />
                        </>
                    ) : (
                        <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => handleDelete(card.Id)}
                        >
                            <Delete style={{ color: '#4b6bcc' }} />
                        </IconButton>
                    )}
                </ListItemSecondaryAction>
            </ListItem>
            {index !== lastItemIndex && <Divider variant="middle" />}
        </React.Fragment>
    );
};

export default ManageCards;
